import React from "react";

const BulletPoint = ({
  color = "currentColor",
  size = 24,
  className = "",
}) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color }}
  >
    <g>
      <path
        d="M3.5 7.5C4.32843 7.5 5 6.82843 5 6C5 5.17157 4.32843 4.5 3.5 4.5C2.67157 4.5 2 5.17157 2 6C2 6.82843 2.67157 7.5 3.5 7.5Z"
        fill="currentColor"
      />
      <path
        d="M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H8Z"
        fill="currentColor"
      />
      <path
        d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H8Z"
        fill="currentColor"
      />
      <path
        d="M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z"
        fill="currentColor"
      />
      <path
        d="M5 12C5 12.8284 4.32843 13.5 3.5 13.5C2.67157 13.5 2 12.8284 2 12C2 11.1716 2.67157 10.5 3.5 10.5C4.32843 10.5 5 11.1716 5 12Z"
        fill="currentColor"
      />
      <path
        d="M3.5 19.5C4.32843 19.5 5 18.8284 5 18C5 17.1716 4.32843 16.5 3.5 16.5C2.67157 16.5 2 17.1716 2 18C2 18.8284 2.67157 19.5 3.5 19.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default BulletPoint;
